import React from 'react';

const CLOUDS = [
  { left: '8%', top: '18%', width: 120, height: 40 },
  { left: '78%', top: '24%', width: 150, height: 46 },
  { left: '62%', top: '70%', width: 130, height: 42 },
  { left: '14%', top: '66%', width: 110, height: 36 },
];

const SPARKLE_CHARS = ['✦', '✧', '⭐', '✨', '🌟'];
const SPARKLE_COLORS = ['#ff7ab8', '#b388ff', '#ffe27a', '#fff'];

function MoeFx({ sparkles: showSparkles = true }) {
  const sparkles = React.useMemo(
    () =>
      Array.from({ length: 22 }).map((_, i) => ({
        char: SPARKLE_CHARS[i % SPARKLE_CHARS.length],
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        fontSize: 14 + Math.random() * 16 + 'px',
        animationDelay: -Math.random() * 2.4 + 's',
        color: SPARKLE_COLORS[i % SPARKLE_COLORS.length],
      })),
    []
  );

  return (
    <>
      <div className="moe-burst" aria-hidden="true" />
      {CLOUDS.map((c, i) => (
        <div
          key={i}
          className="moe-cloud"
          aria-hidden="true"
          style={{ left: c.left, top: c.top, width: c.width, height: c.height }}
        />
      ))}
      {showSparkles && (
      <div className="moe-sparkles" aria-hidden="true">
        {sparkles.map((s, i) => (
          <span
            key={i}
            className="moe-spk"
            style={{
              left: s.left,
              top: s.top,
              fontSize: s.fontSize,
              animationDelay: s.animationDelay,
              color: s.color,
            }}
          >
            {s.char}
          </span>
        ))}
      </div>
      )}
    </>
  );
}

export default MoeFx;
